import { render, staticRenderFns } from "./CartActionMassDelete.vue?vue&type=template&id=2e122d28&"
import script from "./CartActionMassDelete.vue?vue&type=script&lang=ts&"
export * from "./CartActionMassDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports